import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";

export default function Navbar(props) {
	return (
		<div>
			<nav
				className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}
			>
				<div className="container-fluid">
					<a className="navbar-brand" href="/">
						{props.title}
					</a>
					<button
						className="navbar-toggler"
						type="button"
						data-bs-toggle="collapse"
						data-bs-target="#navbarSupportedContent"
						aria-controls="navbarSupportedContent"
						aria-expanded="false"
						aria-label="Toggle navigation"
					>
						<span className="navbar-toggler-icon"></span>
					</button>
					<div className="collapse navbar-collapse" id="navbarSupportedContent">
						<ul className="navbar-nav me-auto mb-2 mb-lg-0">
							<li className="nav-item">
								<Link to="/" className="nav-link" aria-current="page">
									Home
								</Link>
							</li>
							<li className="nav-item">
								<Link to="/about" className="nav-link">
									{props.aboutText}
								</Link>
							</li>
							<li className="nav-item">
								<a
									className="nav-link"
									href={props.googleLink}
									target="_blank"
									rel="noreferrer noopener"
								>
									Google
								</a>
							</li>
						</ul>
						<div className="form-check form-switch">
							<input
								className="form-check-input"
								type="checkbox"
								role="switch"
								id="flexSwitchCheckDefault"
								onClick={props.toggleMode}
							/>
							<label
								className="form-check-label"
								htmlFor="flexSwitchCheckDefault"
								style={{ color: props.mode === "light" ? "black" : "white" }}
							>
								Dark mode
							</label>
						</div>
					</div>
				</div>
			</nav>
		</div>
	);
}

Navbar.propTypes = {
	title: PropTypes.string.isRequired,
	aboutText: PropTypes.string.isRequired,
	googleLink: PropTypes.string,
	mode: PropTypes.string,
	toggleMode: PropTypes.func,
};

Navbar.defaultProps = {
	title: "Title hai ye",
	aboutText: "About hai ye",
	googleLink: "/",
};
